import React, { useState, useContext } from 'react';
import { Switch, Card, Descriptions, Tabs, Popconfirm, Divider, Table, Row, Col, Button, Input, Select, message, Tag, Form, AutoComplete, Modal } from 'antd';
import { UserOutlined, LaptopOutlined, DeleteFilled, NotificationOutlined, RedoOutlined, PlusOutlined, MedicineBoxOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import moment from 'moment'


const columnsMedication = [
    {
      title: 'Brand Name',
      dataIndex: 'brandName',
      key: 'brandName',
      width: '20%'
    },
    {
      title: 'Generic Name',
      dataIndex: 'genericName',
      key: 'diagnosisName',
      width: '10%'
    },
    {
      title: 'Frequency',
      dataIndex: 'frequency',
      key: 'frequency',
      width: '20%',
      // render:(text,record)=>{
      //   return (
      // <p style={{margin:'0px'}}>{`${record.frequency}`}</p>
      //   )
      // }
    },
    {
      title: 'Dosage',
      dataIndex: 'dosage',
      key: 'dosage',
      width: '10%'
    },
    {
      title: 'Dosage Unit',
      dataIndex: 'dosageUnit',
      key: 'dosageUnit',
      width: '10%'
    },
    {
      title: 'ROA',
      dataIndex: 'roa',
      key: 'roa',
      width: '10%'
    },
    {
      title: 'Duration in Days',
      dataIndex: 'duration',
      key: 'duration',
      width: '10%',
      render: (text, record) => {
        return (
          <span>{record.duration}</span>
        )
      }
    },
    // {
    //   title: 'Dosage Date',
    //   dataIndex: 'dosageDate',
    //   key: 'dosageDate',
    //   width: '10%',
    //   render: (text, record) => {
    //     let ddate = record.dosageDate
    //     return (
    //       <>
    //         <span>{ddate != null && moment(ddate[0]).format('DD-MM-YYYY')}</span>
    //         <span> - </span>
    //         <span>{ddate != null && moment(ddate[1]).format('DD-MM-YYYY')}</span> 
    //       </>
    //     )
    //   }
    // },
    // {
    //   title: 'Instructions',
    //   dataIndex: 'instructions',
    //   key: 'instructions',
    //   width: '10%',
    //   render:(text)=>{
    //       return text ? text : '-'
    //   }
    // }
  ];


const OrdersetPreview=(props)=>{
  let tagStyle= {
    marginBottom:'4px',
    wordWrap: 'break-word',
    maxWidth:'400px',
    whiteSpace:'normal'
  }
    return(
        <div>
           <div>
                <h3>Diagnosis</h3>
                <p>{`${props.record.diagnosis} - ${props.record.diagnosisMap ? props.record.diagnosisMap.name : ''}`}</p>
                <Divider/>
            </div>
            {(props.record.ageGroup && props.record.ageGroup.length > 0 || props.record.appliedFor) && 
              <div>
                <h3>Applied For - Age Group / Gender</h3>
                <h4>{props.record.ageGroup && props.record.ageGroup.map((a)=>`${a.type} ${a.ageFrom} Yr - ${a.ageTo} Yr`).join(', ')}</h4>
                <h4>{props.record.appliedFor ? props.record.appliedFor : ''}</h4>
                <Divider/>
                </div>
            }

            {props.record.investigation && 
                <div>
                <h3>Investigations</h3>
                <div style={{display:'flex', flexWrap:'wrap'}}>
                    {props.record.investigationMap.map((a)=>{
                      if(a){
                        return(
                            <Tag style={tagStyle}>{a.serviceName}</Tag>
                        )
                      }
                    })}
                </div>
            </div>
            }

        <Divider/>
            {props.record.procedure && 
                <div>
                <h3>Procedures</h3>
                <div style={{display:'flex', flexWrap:'wrap'}}>
                    {props.record.procedureMap.map((a)=>{
                      if(a){
                        return(
                            <Tag style={tagStyle}>{a.serviceName}</Tag>

                        )
                      }
                    })}
                </div>
            </div>
            }
  <Divider/>
      
        {props.record.medication && 
        <div>
            <h3>Medication</h3>
            <Table size="small" style={{ width: '100%' }} columns={columnsMedication} dataSource={props.record.medication} pagination={false} />
            <Divider/>
            </div>
            }

{props.record.advice && 
                <div>
                <h3>Advices</h3>
                <div style={{display:'flex', flexWrap:'wrap'}}>
                    {props.record.adviceMap.map((a)=>{
                      if(a){
                        return(
                            <Tag style={tagStyle}>{a.adviceName}</Tag>
                        )
                      }
                    })}
                </div>
                <Divider/>
            </div>
            }
{props.record.note && 
            <div>
                <h3>Instructions</h3>
                <p>{props.record.note}</p>
                <Divider/>
            </div>
            }
           

        </div>
    )
}
export default OrdersetPreview;